import { Currency } from '~/Api/Currency';

import ActionTypes from './ActionTypes';

export interface State {
	request: Promise<any> | null;
	isFetching: boolean;
	currencies: Currency[] | null;
}

type Action =
	| { type: ActionTypes.request; request: Promise<any> }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			currencies: Currency[] | null;
	  };

function createState(): State {
	return {
		request: null,
		isFetching: false,
		currencies: null,
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				request: action.request,
				isFetching: true,
				currencies: null,
			};

		case ActionTypes.receive:
			return state.request === action.request
				? {
						...state,
						request: action.currencies ? action.request : null,
						isFetching: false,
						currencies: action.currencies,
				  }
				: state;

		default:
			return state;
	}
}

export function selectCurrency(currencies: Currency[] | null, code: string): Currency | null {
	return currencies ? currencies.find((currency) => currency.code === code) || null : null;
}
